import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account Redux states
import { CREATE_REGISTRATION_PENDING_USER, GET_REGISTRATION_PENDING_USER_BY_ID, REGISTER_USER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed, createRegistrationPendingUserSuccess, createRegistrationPendingUserFailure, getRegistrationPendingUserByIdSuccess, getRegistrationPendingUserByIdError } from "./actions"

import { AppConfiguration } from "config"

import {
  genericGetRequest,
  genericPostRequest,
  postJwtRegister
} from "../../../helpers/sf_backend_helper"
import _ from "lodash"

// initialize relavant method of both Auth

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user_details, history, new_stripe_setup } }) {
  try {
    let temp_user = user_details
    if (new_stripe_setup) {
      temp_user = _.omit(temp_user, ['card_number', 'card_expiry_month', 'card_expiry_year', 'card_cvv']) 
      temp_user.new_stripe_setup = true
    }
    const response = yield call(
      postJwtRegister,
      `${AppConfiguration.BACKEND_URL}/api/v1/signup`,
      temp_user)
    
    yield put(registerUserSuccessful(response))
  
    //TODO: Fix the flash message clearance from previous step
    history.push("/login?registration=success")
  } catch (error) {
    yield put(registerUserFailed(error))
  }
}

function* addRegistrationPendingUser(action) {
  try {
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/registration_pending_users`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );
    yield put(createRegistrationPendingUserSuccess(response))
  } catch (error) {
    yield put(createRegistrationPendingUserFailure(error))
  }
}

function* onGetRegistrationPendingUserById(action) {
  try {
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/registration_pending_users/${action.payload.id}`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    yield put(getRegistrationPendingUserByIdSuccess(response))
  } catch (error) {
    yield put(getRegistrationPendingUserByIdError(error))
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser)
  yield takeEvery(CREATE_REGISTRATION_PENDING_USER, addRegistrationPendingUser)
  yield takeEvery(GET_REGISTRATION_PENDING_USER_BY_ID, onGetRegistrationPendingUserById)
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
